<template>
  <div class="content">
    <div class="content_title">
      Добавить организацию
    </div>
    <div class="main row">
      <div class="form-row">
        <div class="form-field">
          <b>Реквизиты организации</b>
        </div>
        <div class="form-field">
          <label for="inn-input">ИНН:</label>
          <input id="inn-input" v-model="org.INN" type="text" />
        </div>
        <div class="form-field">
          <button @click="getOrgDaData">Загрузить данные по ИНН</button>
        </div>
        <div class="form-field">
          <label for="reg-org-type">Тип:</label>
          <select id="reg-org-type" v-model="org.TYPE">
            <option value="ooo">ООО</option>
            <option value="ip">ИП</option>
            <option value="fiz">Физическое лицо</option>
          </select>
        </div>
        <div class="form-field">
          <label for="short-name-input">Сокращенное наименование:</label>
          <input id="short-name-input" v-model="org.SHORT_NAME" type="text" />
        </div>
        <div class="form-field">
          <label for="full-name-input">Полное наименование:</label>
          <input id="full-name-input" v-model="org.FULL_NAME" type="text" />
        </div>
        <div class="form-field">
          <label for="ogrn-input">ОГРН:</label>
          <input id="ogrn-input" v-model="org.OGRN" type="text" />
        </div>
        <div class="form-field">
          <label for="kpp-input">КПП:</label>
          <input id="kpp-input" v-model="org.KPP" type="text" />
        </div>
        <div class="form-field">
          <label for="reg-date-input">Дата государственной регистрации:</label>
          <input id="reg-date-input" v-model="org.REG_DATE" type="text" />
        </div>
        <div class="form-field">
          <label for="okpo-input">ОКПО:</label>
          <input id="okpo-input" v-model="org.OKPO" type="text" />
        </div>
        <div class="form-field">
          <label for="oktmo-input">ОКТМО:</label>
          <input id="oktmo-input" v-model="org.OKTMO" type="text" />
        </div>
        <div class="form-field">
          <label for="gen-dir-input">Генеральный директор:</label>
          <input id="gen-dir-input" v-model="org.GEN_DIR" type="text" />
        </div>
        <div class="form-field">
          <label for="address-input">Адрес:</label>
          <input id="address-input" v-model="org.ADDRESS" type="text" />
        </div>
        <div class="form-field">
          <label for="paymaster-input">Кассир:</label>
          <input id="paymaster-input" v-model="org.PAYMASTER" type="text" />
        </div>
        <div class="form-field">
          <label for="my-org-input">Моя организация:</label>
          <select id="my-org-input" v-model="org.MY_ORG">
            <option value="Y">Да</option>
            <option value="N">Нет</option>
          </select>
        </div>
      </div>
      <div class="form-row">
        <div class="form-field">
          <b>Банковские реквизиты</b>
        </div>
        <div class="form-field">
          <label for="bank-name-input">Название:</label>
          <input id="bank-name-input" v-model="org.BANK_NAME" type="text" />
        </div>
        <div class="form-field">
          <label for="bank-full-name-input">Наименование банка:</label>
          <input
            id="bank-full-name-input"
            v-model="org.BANK_FULL_NAME"
            type="text"
          />
        </div>
        <div class="form-field">
          <label for="bank-bik-input">БИК:</label>
          <input id="bank-bik-input" v-model="org.BANK_BIK" type="text" />
        </div>
        <div class="form-field">
          <label for="bank-inv-input">Расчетный счет:</label>
          <input id="bank-inv-input" v-model="org.BANK_INV" type="text" />
        </div>
        <div class="form-field">
          <label for="bank-kor-inv-input">Кор. счет:</label>
          <input
            id="bank-kor-inv-input"
            v-model="org.BANK_KOR_INV"
            type="text"
          />
        </div>
      </div>
    </div>
    <div class="main row">
      <div class="form-row">
        <div class="form-field">
          <button @click="sendOrgData">Создать</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import config from "@/config";

export default {
  name: "GetAgreements",
  data() {
    return {
      url: config.backend_url,
      org: {
        TYPE: null,
        INN: null,
        SHORT_NAME: null,
        FULL_NAME: null,
        OGRN: null,
        KPP: null,
        REG_DATE: null,
        OKPO: null,
        OKTMO: null,
        GEN_DIR: null,
        ADDRESS: null,
        PAYMASTER: null,
        MY_ORG: null,
        BANK_NAME: null,
        BANK_FULL_NAME: null,
        BANK_BIK: null,
        BANK_INV: null,
        BANK_KOR_INV: null
      }
    };
  },
  methods: {
    getOrgDaData: function() {
      let url =
        "https://suggestions.dadata.ru/suggestions/api/4_1/rs/findById/party";
      let token = "e6e674f376b1d4c0005f6352578e2794a8d9c0ff";

      let options = {
        method: "POST",
        mode: "cors",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          Authorization: "Token " + token
        },
        body: JSON.stringify({ query: this.org.INN })
      };

      if (this.org.INN) {
        fetch(url, options)
          .then(response => response.text())
          .then(result => {
            let data = JSON.parse(result).suggestions[0].data;

            this.org.TYPE = null;
            this.org.INN = data.inn;
            this.org.SHORT_NAME = data.name.short_with_opf;
            this.org.FULL_NAME = data.name.full_with_opf;
            this.org.OGRN = data.ogrn;
            this.org.KPP = data.kpp;
            this.org.REG_DATE = this.timeConverter(
              data.state.registration_date
            );
            this.org.OKPO = data.okpo;
            this.org.OKTMO = data.oktmo;
            this.org.GEN_DIR = data.management.name;
            this.org.ADDRESS = data.address.value;
            this.org.PAYMASTER = null;
            this.org.MY_ORG = null;
            this.org.BANK_NAME = null;
            this.org.BANK_FULL_NAME = null;
            this.org.BANK_BIK = null;
            this.org.BANK_INV = null;
            this.org.BANK_KOR_INV = null;
            console.log(data);
          })
          .catch(error => console.log("error", error));
      }
    },
    timeConverter: function(UNIX_timestamp) {
      let a = new Date(UNIX_timestamp);
      let year = a.getFullYear();
      let month = a.getMonth();
      let date = a.getDate();
      return date + "." + month + "." + year;
    },
    sendOrgData: function() {
      this.$store
        .dispatch("query/sendRequest", {
          url: this.url + "companies/add/",
          data: this.org,
          method: "POST"
        })
        .then(response => {
          let data = response.data;
          if (data.companies) alert("Компания успешно добавлена");
        });
    }
  }
};
</script>
